import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const TablaPDF = () => {
  const tablaRef = useRef(null);

  const handleDownloadPDF = () => {
    const input = tablaRef.current;
    
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190; // Ancho máximo en mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('tabla-descargada.pdf');
    });
  };

  return (
    <div>
      <button 
        onClick={handleDownloadPDF}
        style={{
          padding: '10px 20px',
          background: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          margin: '20px'
        }}
      >
        Descargar PDF
      </button>

      <div ref={tablaRef}>
        <table style={{
          borderCollapse: 'collapse',
          width: '100%',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.15)'
        }}>
          <thead>
            <tr style={{ 
              backgroundColor: '#009879',
              color: 'white',
              textAlign: 'left'
            }}>
              <th style={{ padding: '12px 15px' }}>ID</th>
              <th style={{ padding: '12px 15px' }}>Nombre</th>
              <th style={{ padding: '12px 15px' }}>Email</th>
              <th style={{ padding: '12px 15px' }}>País</th>
            </tr>
          </thead>
          <tbody>
            {[['1', 'Juan Pérez', 'juan@example.com', 'México'],
              ['2', 'María García', 'maria@example.com', 'España'],
              ['3', 'John Doe', 'john@example.com', 'USA']].map((row, index) => (
                <tr key={index} style={{ 
                  borderBottom: '1px solid #dddddd',
                  backgroundColor: index % 2 === 0 ? '#f3f3f3' : 'white'
                }}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} style={{ 
                      padding: '12px 15px',
                      color: '#333'
                    }}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TablaPDF;